// extracted by mini-css-extract-plugin
module.exports = {"button":"_34wpk","hiddenLabel":"BkwNc"};